import PropTypes from "prop-types";
import React from "react";

export function TabPanel(props) {
  const { children, value, label, ...rest } = props;
  const defaultStyle = { height: "100%", width: "100%" };

  return (
    <div
      role="tabpanel"
      hidden={value !== label}
      style={defaultStyle}
      {...rest}
    >
      {value === label && children}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
